import { Mode } from '@/common/entityFramework/enumerations/Mode';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';

const aesScSideNav = {
  id: 'sc',
  children: [
    {
      id: 'scDirSalesMenu',
      children: [
        {
          id: 'scDirSaleDashboard',
          displayName: 'Sale Dashboard',
          role: 'SC_DIR_SALE_VIEW',
          icon: fas.faChartBar,
          route: '/sc/dir-sale-dashboard',
          precedence: 3,
        },
      ],
    },

    {
      id: 'scBestPriceDashboard',
      displayName: 'Best Price Dashboard',
      role: 'SC_AES_BEST_PRICE_VIEW',
      icon: fas.faChartBar,
      route: '/sc/best-price-dashboard',
      precedence: 13.5,
    },
    {
      id: 'scFilter',
      displayName: 'Global Sales Filters',
      icon: fas.faClipboard,
      route: '/sc/filter',
      role: 'SC_FILTER_VIEW',
      precedence: 37,
      state: { mode: Mode.DETAIL },
    },
  ],
};

export default aesScSideNav;
